import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20.2921 21.707L11.5861 13H7.0001V11H9.5861L7.5861 9.00003H7.0001C5.34324 9.00003 4.0001 10.3432 4.0001 12C4.0001 13.6569 5.34324 15 7.0001 15H10.0001V17H7.0001C4.48165 17.0021 2.35474 15.1308 2.03615 12.6325C1.71756 10.1343 3.30674 7.78908 5.7451 7.15903L2.2921 3.70703L3.7071 2.29303L21.7071 20.293L20.2931 21.706L20.2921 21.707ZM20.1361 15.893L18.7081 14.466C19.7866 13.7189 20.2544 12.3576 19.8631 11.1053C19.4718 9.85297 18.3121 9.00023 17.0001 9.00003H14.0001V7.00003H17.0001C19.1201 7.00029 21.0095 8.33747 21.7147 10.3367C22.42 12.336 21.7877 14.5627 20.1371 15.893H20.1361Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Unlink"
);
